/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1);
__webpack_require__(2);
__webpack_require__(3);
module.exports = __webpack_require__(4);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
Constructor for the tooltip
@ param options an object containing: marker(required), content(required) and cssClass(a css class, optional)
@ see google.maps.OverlayView()
*/
window.Tooltip = function (options) {

    // Now initialize all properties.
    this.marker_ = options.marker;
    this.content_ = options.content;
    this.map_ = options.marker.get('map');
    this.cssClass_ = options.cssClass || null;

    // We define a property to hold the content's
    // div. We'll actually create this div
    // upon receipt of the add() method so we'll
    // leave it null for now.
    this.div_ = null;

    //Explicitly call setMap on this overlay
    this.setMap(this.map_);
    var me = this;
    // Show tooltip on mouseover event.
    google.maps.event.addListener(me.marker_, 'mouseover', function () {
        me.show();
    });
    // Hide tooltip on mouseout event.
    google.maps.event.addListener(me.marker_, 'mouseout', function () {
        me.hide();
    });
};
// Now we extend google.maps.OverlayView()
Tooltip.prototype = new google.maps.OverlayView();

// onAdd is one of the functions that we must implement,
// it will be called when the map is ready for the overlay to be attached.
Tooltip.prototype.onAdd = function () {

    // Create the DIV and set some basic attributes.
    var div = document.createElement('DIV');
    div.style.position = "absolute";
    // Hide tooltip
    div.style.visibility = "hidden";
    if (this.cssClass_) div.className += " " + this.cssClass_;

    //Attach content to the DIV.
    div.innerHTML = this.content_;

    // Set the overlay's div_ property to this DIV
    this.div_ = div;

    // We add an overlay to a map via one of the map's panes.
    // We'll add this overlay to the floatPane pane.
    var panes = this.getPanes();
    panes.floatPane.appendChild(this.div_);
};
// We here implement draw
Tooltip.prototype.draw = function () {

    // Position the overlay. We use the position of the marker
    // to peg it to the correct position, just northeast of the marker.
    // We need to retrieve the projection from this overlay to do this.
    var overlayProjection = this.getProjection();

    // Retrieve the coordinates of the marker
    // in latlngs and convert them to pixels coordinates.
    // We'll use these coordinates to place the DIV.
    var ne = overlayProjection.fromLatLngToDivPixel(this.marker_.getPosition());

    // Position the DIV.
    var div = this.div_;
    div.style.left = ne.x + 'px';
    div.style.top = ne.y + 'px';
};
// We here implement onRemove
Tooltip.prototype.onRemove = function () {
    this.div_.parentNode.removeChild(this.div_);
};

// Note that the visibility property must be a string enclosed in quotes
Tooltip.prototype.hide = function () {
    if (this.div_) {
        this.div_.style.visibility = "hidden";
    }
};

Tooltip.prototype.show = function () {
    if (this.div_) {
        this.div_.style.visibility = "visible";
    }
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

$(function () {
    /**
     * Fastclick
     */
    FastClick.attach(document.body);

    /**
     * FitVids
     */
    $('.Grid').fitVids();

    /**
     * Open / close Submavigation on non-mobile devices
     */
    $('.Navigation a').on('click', function (event) {
        var subnav = $('.Header nav > .Subnavigation[data-parent=' + $(this).data('id') + ']');

        if (subnav.length) {
            event.preventDefault();

            if ($('.Header .mobile').hasClass('open')) {
                return;
            }

            if (subnav.hasClass('open')) {
                subnav.slideUp(150).removeClass('open').children('*').fadeOut(100);
                return;
            }

            var timer = 1;
            if ($('.Header nav > .Subnavigation.open').length) {
                $('.Header nav > .Subnavigation.open').slideUp(150).removeClass('open').children('*').fadeOut(100);
                timer = 150;
            }

            setTimeout(function () {
                subnav.slideDown(300).addClass('open').children('*').fadeOut(0);
                setTimeout(function () {
                    subnav.children('*').fadeIn(300);
                }, 150);
            }, timer);
        }
    });

    /**
     * Open / close menu on mobile devices
     */
    $('.btn-menu, .btn-close', '.Header .mobile').on('click', function () {
        $('.Header .mobile').toggleClass('open');
    });

    /**
     * Scrool top
     */
    $('.Footer .back-to-top img').on('click', function () {
        $('html, body').animate({ scrollTop: 0 });
    });

    /**
     * Grid scroll animation
     */
    $('.Grid__row, .Flickity').waypoint({
        handler: function handler(direction) {
            if ($(this.element).hasClass('Flickity')) {
                var element = $(this.element);
                setTimeout(function () {
                    element.animate({
                        opacity: 1,
                        top: 0
                    }, 700);
                }, i++ * 150);
            }

            var i = 0;
            $(this.element).find('.Grid__row__col').each(function () {
                var element = $(this);
                setTimeout(function () {
                    element.animate({
                        opacity: 1,
                        top: 0
                    }, 700);
                }, i++ * 150);
            });
        },
        offset: '75%'
    });

    /**
     * lightbox options
     */
    lightbox.option({
        disableScrolling: true
    });

    /**
     * Flickity
     */
    $('.Flickity').flickity({
        cellSelector: '.Flickity__item',
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        setGallerySize: false
    });

    /**
     * jQuery placeholder
     */
    $('input, textarea').placeholder();

    /**
     * Homepage Phase 2 modal window
     */
    $('#phase2-modal-trigger').fancybox({
        wrapCSS: 'phase2-modal',
        //padding: [60, 45, 60, 45],
        padding: [0, 0, 0, 0],
        autoHeight: true,
        scrolling: 'no',
        maxWidth: '100%',
        fitToView: false,
        autoPlay: false,
        loop: false,
        type: 'inline',
        helpers: {
            overlay: {
                showEarly: true,
                css: {
                    background: 'rgba(255,255,255,0.75)'
                }
            }
        }
    });
    $('#phase2-modal-trigger').trigger('click');

    /**
     * Homepage Available Units modal window
     */
    $('#available-units-modal-trigger').fancybox({
        wrapCSS: 'available-units-modal',
        padding: [50, 45, 40, 45],
        autoHeight: true,
        scrolling: 'no',
        minWidth: '100%',
        maxWidth: 600,
        fitToView: true,
        autoPlay: false,
        loop: false,
        type: 'inline',
        helpers: {
            overlay: {
                showEarly: true,
                css: {
                    background: 'rgba(255,255,255,0.75)'
                }
            }
        }
    });
    $('#available-units-modal-trigger').trigger('click');

    /**
     * Homepage Spaces for rent modal window
     */
    $('#spaces-for-rent-modal-trigger').fancybox({
        wrapCSS: 'spaces-for-rent-modal',
        padding: [30, 40, 30, 40],
        autoHeight: true,
        scrolling: 'auto',
        minWidth: '100%',
        maxWidth: 600,
        fitToView: true,
        autoPlay: false,
        loop: false,
        type: 'inline',
        helpers: {
            overlay: {
                showEarly: true,
                css: {
                    background: 'rgba(255,255,255,0.75)'
                }
            }
        }
    });
    $('#spaces-for-rent-modal-trigger').trigger('click');

    /**
     * Image gallery
     */
    var $gallery = $('.gallery-grid').isotope({
        itemSelector: '.grid-item',
        percentPosition: true,
        masonry: {
            columnWidth: '.grid-sizer'
        }
    });
    // layout Isotope after each image loads
    $gallery.imagesLoaded().progress(function () {
        $gallery.isotope('layout');
    });
    // fancybox
    $('.gallery-grid .fancybox').fancybox({
        padding: 0,
        helpers: {
            overlay: {
                css: {
                    'background': 'rgba(0,0,49,0.8)'
                }
            }
        },
        nextEffect: 'fade',
        prevEffect: 'fade'
    });
});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

/**
 * Google map default options
 */
var defaultMapOptions = {
    zoom: 16,
    center: new google.maps.LatLng(45.510450, -73.565676),
    backgroundColor: '#ffffff',
    scrollwheel: false,
    styles: [{
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [{
            "saturation": 36
        }, {
            "color": "#333333"
        }, {
            "lightness": 40
        }]
    }, {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "visibility": "on"
        }, {
            "color": "#ffffff"
        }, {
            "lightness": 16
        }]
    }, {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [{
            "visibility": "off"
        }]
    }, {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [{
            "lightness": 20
        }, {
            "color": "#fefefe"
        }]
    }, {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [{
            "lightness": 17
        }, {
            "weight": 1.2
        }, {
            "color": "#fefefe"
        }]
    }, {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#000000"
        }]
    }, {
        "featureType": "administrative.locality",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "visibility": "on"
        }, {
            "color": "#e2e2e2"
        }]
    }, {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#000000"
        }]
    }, {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "visibility": "on"
        }, {
            "color": "#e2e2e2"
        }]
    }, {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [{
            "lightness": 20
        }, {
            "color": "#ffffff"
        }]
    }, {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [{
            "color": "#f5f5f5"
        }, {
            "lightness": 21
        }]
    }, {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [{
            "visibility": "off"
        }]
    }, {
        "featureType": "poi.attraction",
        "elementType": "geometry",
        "stylers": [{
            "visibility": "off"
        }]
    }, {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [{
            "color": "#7cb18c"
        }, {
            "lightness": 21
        }]
    }, {
        "featureType": "poi.place_of_worship",
        "elementType": "geometry",
        "stylers": [{
            "visibility": "off"
        }]
    }, {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#e2e2e2"
        }, {
            "lightness": 17
        }]
    }, {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [{
            "color": "#ffffff"
        }, {
            "lightness": 29
        }, {
            "weight": 0.2
        }, {
            "visibility": "off"
        }]
    }, {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#000000"
        }, {
            "visibility": "on"
        }]
    }, {
        "featureType": "road.highway",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "visibility": "off"
        }]
    }, {
        "featureType": "road.highway.controlled_access",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#000000"
        }]
    }, {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [{
            "color": "#e2e2e2"
        }, {
            "lightness": 18
        }]
    }, {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#000000"
        }, {
            "visibility": "on"
        }]
    }, {
        "featureType": "road.arterial",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "visibility": "off"
        }]
    }, {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [{
            "lightness": 16
        }, {
            "color": "#e2e2e2"
        }]
    }, {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [{
            "visibility": "on"
        }, {
            "color": "#000000"
        }]
    }, {
        "featureType": "road.local",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "color": "#c27171"
        }, {
            "visibility": "off"
        }]
    }, {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [{
            "visibility": "off"
        }]
    }, {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [{
            "color": "#f2f2f2"
        }, {
            "lightness": 19
        }, {
            "visibility": "off"
        }]
    }, {
        "featureType": "transit",
        "elementType": "labels",
        "stylers": [{
            "visibility": "on"
        }]
    }, {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{
            "lightness": 17
        }, {
            "visibility": "on"
        }, {
            "color": "#cccccc"
        }]
    }, {
        "featureType": "water",
        "elementType": "labels.text",
        "stylers": [{
            "visibility": "off"
        }]
    }]
};

$(function () {
    if (!$('#map-canvas').length) {
        return;
    }

    /**
     * Map
     */
    map = new google.maps.Map(document.getElementById('map-canvas'), defaultMapOptions);

    new google.maps.Marker({
        position: new google.maps.LatLng(45.51047742938552, -73.56580688095096),
        map: map,
        icon: {
            path: "M15.955,17.804L11,14.204l-4.955,3.6l1.893-5.825l-4.956-3.6h6.125L11,2.553l1.893,5.825h6.125l-4.955,3.601 L15.955,17.804",
            fillColor: '#fff',
            fillOpacity: 1,
            anchor: new google.maps.Point(11, 11),
            strokeWeight: 0,
            scale: 1.3
        }
    });

    var building = new google.maps.Marker({
        position: new google.maps.LatLng(45.51047742938552, -73.56580688095096),
        map: map,
        icon: {
            path: "M11,0C4.925,0,0,4.925,0,11s4.925,11,11,11s11-4.925,11-11S17.075,0,11,0z M15.955,17.804L11,14.204 l-4.955,3.6l1.893-5.825l-4.956-3.6h6.125L11,2.553l1.893,5.825h6.125l-4.955,3.601L15.955,17.804z",
            fillColor: '#ef4b58',
            fillOpacity: 1,
            anchor: new google.maps.Point(11, 11),
            strokeWeight: 0,
            scale: 1.3
        }
    });

    var tooltip = new Tooltip({
        marker: building,
        content: 'Laurent &amp; Clark',
        cssClass: 'tooltip-label tooltip-building'
    });

    // Markers
    var markers = [];

    $('.Map__navigation li').each(function () {
        var nav_element = $(this);

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng($(this).data('latitude'), $(this).data('longitude')),
            icon: '/images/frontend/marker.png',
            map: map
        });

        var content = $(this).find('.title').clone();

        content.children('.material-icons').remove();

        var tooltip = new Tooltip({
            marker: marker,
            content: content.html(),
            cssClass: 'tooltip-label'
        });

        google.maps.event.addListener(marker, 'click', function () {
            map.panTo(this.getPosition());
            setTimeout(function () {
                for (id in markers) {
                    markers[id].tooltip.hide();
                }
                tooltip.show();
            }, 100);

            $('.Map').addClass('Map--navigation-opened');

            $('.Map__navigation ul').getNiceScroll().doScrollPos(0, nav_element.position().top);

            nav_element.addClass('active').siblings().removeClass('active');
        });
        markers[$(this).data('id')] = { marker: marker, tooltip: tooltip };
    });

    /**
     * Navigation
     */
    $('.Map__navigation ul').niceScroll({
        cursorwidth: 10,
        cursorborderradius: 0
    });

    $('.Map__navigation .close-panel').on('click', function () {
        $('.Map').toggleClass('Map--navigation-opened');
    });

    $('.Map__navigation li').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');

        for (id in markers) {
            markers[id].tooltip.hide();
        }

        var marker = markers[$(this).data('id')];

        marker.tooltip.show();

        map.panTo(marker.marker.getPosition());
    });

    /**
     * Filters
     */
    $('.MapFilters a').on('click', function (event) {
        event.preventDefault();

        var hash = $(this).attr('href').substr(1);

        if ($(this).hasClass('active') || hash == 'all') {
            for (id in markers) {
                var marker = markers[id];
                marker.marker.setVisible(true);
            }

            $('.Map__navigation li').show();

            $('.MapFilters a').removeClass('active');

            $('.MapFilters a[href="#all"]').addClass('active');

            return;
        }

        for (id in markers) {
            var marker = markers[id];
            marker.marker.setVisible(false);
        }

        $('.MapFilters a').removeClass('active');

        $(this).addClass('active');

        $('.Map__navigation li').hide();

        $('.Map__navigation li[data-category="' + hash + '"]').each(function () {
            $(this).show();
            markers[$(this).data('id')].marker.setVisible(true);
        });

        $('.Map').addClass('Map--navigation-opened');
    });
});

/***/ }),
/* 4 */
/***/ (function(module, exports) {

$(function () {

    $('.AvailableUnits__toggle').on('click', function () {
        $('.AvailableUnits__content').slideToggle();
    });

    $('.AvailableUnits__unit').on('click', function () {
        var floor = $(this).data('floor');
        var phase = $(this).data('phase');
        displayFloor(floor, phase);

        var unit = $(this).data('unit');
        displayUnit(unit);

        $('html, body').animate({
            scrollTop: $('.Plan').offset().top
        });
    });

    $('.plan-availability').on('click', function () {
        $('html, body').animate({
            scrollTop: $('.Plan').offset().top
        });
    });

    $('.Plan__overview select').on('create', function () {
        $('.selectboxit-arrow').text('keyboard_arrow_down');
    }).on('change', function (event) {
        var bedrooms = $('.Plan__overview__options [name=bedrooms]').val();
        var surface_area = $('.Plan__overview__options [name=surface-area]').val();

        var conditions = {};
        if (bedrooms != 'all') {
            conditions.bedrooms = bedrooms;
        }

        if (surface_area != 'all') {
            conditions.surface_area = surface_area;
        }

        $('.Plan__overview__floor.active').removeClass('active');

        if (false == (conditions.hasOwnProperty('bedrooms') || conditions.hasOwnProperty('surface_area'))) {
            return;
        }

        conditions.status = "available";

        $.ajax({
            url: '/api/plans',
            type: 'get',
            data: conditions
        }).done(function (data) {
            var floors = {};

            $.each(data, function (index, unit) {
                floors[unit.phase + '-' + unit.floor] = true;
            });

            for (key in floors) {
                key = key.split('-');
                phase = key[0];
                floor = key[1];

                $('.Plan__overview__floor[data-floor=' + floor + '][data-phase=' + phase + ']').addClass('active');
            }
        });
    }).selectBoxIt({
        hideCurrent: true,
        autoWidth: false,
        downArrowIcon: 'material-icons',
        dynamicPositioning: false
    });

    $('.Plan__overview__floor').on('click', function () {
        var floor = $(this).data('floor');
        var phase = $(this).data('phase');
        displayFloor(floor, phase);
    });

    $('.Plan__details .back-to-the-future').on('click', function (event) {
        event.preventDefault();

        $('.Plan > .container').fadeToggle(function () {
            $('.Plan__overview').fadeToggle();
        });
    });

    if ($('#hbs-unit').size()) {
        var hbs_details = Handlebars.compile($('#hbs-unit').html());
    }

    $('.Plan').on('click', '.Plan__details__floor__unit', function () {
        var unit = $(this).data('unit');
        displayUnit(unit);
    });

    function displayFloor(floor, phase) {

        var conditions = {
            floor: floor,
            phase: phase
        };

        $.ajax({
            url: '/api/plans',
            type: 'get',
            data: conditions
        }).done(function (data) {
            var svg = $('.Plan__details #floor-p' + phase + '-' + floor);

            $('.Plan__details svg').hide();
            $('.Plan__details__floor__filters li').remove();
            $('.Plan .Plan__details__unit').remove();
            $('.Plan__details__floor__unit').removeClass('Plan__details__floor__unit--available');
            $('.Plan__details__floor__unit').removeClass('Plan__details__floor__unit--booked');
            $('.Plan__details__floor__unit').removeClass('Plan__details__floor__unit--sold');
            $('.Plan__details__floor__unit').removeClass('active');

            if ($('.Plan__overview select[name=bedrooms]').val() != 'all') {
                var text = $('.Plan__overview select[name=bedrooms] option[value="' + $('.Plan__overview select[name=bedrooms]').val() + '"]').text();
                $('.Plan__details__floor__filters').append($('<li/>').text(text));
            }

            if ($('.Plan__overview select[name=surface-area]').val() != 'all') {
                var text = $('.Plan__overview select[name=surface-area] option[value="' + $('.Plan__overview select[name=surface-area]').val() + '"]').text();
                $('.Plan__details__floor__filters').append($('<li/>').text(text));
            }

            $.each(data, function (index, unit) {
                var element = svg.find('[data-unit="' + unit.suite + '"]');

                element.addClass('Plan__details__floor__unit--' + unit.status);

                var bedrooms = $('.Plan__overview select[name=bedrooms]').val();

                var surface_area = $('.Plan__overview select[name=surface-area]').val();

                if (bedrooms != 'all' && surface_area != 'all') {
                    if (bedrooms == unit.bedrooms && surface_area == unit['surface-area']) {
                        element.addClass('active');
                    }
                } else if (bedrooms != 'all' && surface_area == 'all') {
                    if (bedrooms == unit.bedrooms) {
                        element.addClass('active');
                    }
                } else if (bedrooms == 'all' && surface_area != 'all') {
                    if (surface_area == unit['surface-area']) {
                        element.addClass('active');
                    }
                }
            });

            $('.Plan__details__floor__title span').text(floor);

            $('.Plan__details__floor__caption .panorama a.hidden').remove();

            if (phase == 1) {
                var panorama_file = '/images/frontend/panoramas/p1/';

                if (floor >= 1 && floor <= 3) {
                    panorama_file += '1-3.jpg';
                } else if (floor >= 4 && floor <= 7) {
                    panorama_file += '4-7.jpg';
                } else if (floor >= 8 && floor <= 11) {
                    panorama_file += '8-11.jpg';
                } else if (floor >= 12 && floor <= 16) {
                    panorama_file += '12-16.jpg';
                } else if (floor >= 17 && floor <= 20) {
                    panorama_file += '17-20.jpg';
                }

                $('.Plan__details__floor__caption .panorama a:first').attr('href', panorama_file);
            } else if (phase == 2) {
                var panorama_file = '/images/frontend/panoramas/p2/';
                var images = [];

                if (floor >= 1 && floor <= 4) {
                    images = ['2-6-o.jpg', '2-6-s.jpg', '2-6-e.jpg'];
                } else if (floor >= 5 && floor <= 6) {
                    images = ['2-6-o.jpg', '2-6-s.jpg', '2-6-e.jpg', '2-6-n.jpg'];
                } else if (floor >= 7 && floor <= 9) {
                    images = ['7-9-o.jpg', '7-9-s.jpg', '7-9-e.jpg', '7-9-n.jpg'];
                } else if (floor >= 10 && floor <= 14) {
                    images = ['10-14-o.jpg', '10-14-s.jpg', '10-14-e.jpg', '10-14-n.jpg'];
                } else if (floor >= 15 && floor <= 18) {
                    images = ['15-18-o.jpg', '15-18-s.jpg', '15-18-e.jpg', '15-18-n.jpg'];
                } else if (floor >= 19 && floor <= 22) {
                    images = ['19-22-o.jpg', '19-22-s.jpg', '19-22-e.jpg', '19-22-n.jpg'];
                } else if (floor >= 23 && floor <= 24) {
                    images = ['23-24-o.jpg', '23-24-s.jpg', '23-24-e.jpg', '23-24-n.jpg'];
                } else if (floor == 25) {
                    images = ['25-s.jpg', '25-e.jpg', '25-n.jpg'];
                }

                for (index in images) {
                    var image = images[index];

                    if (index == 0) {
                        $('.Plan__details__floor__caption .panorama a:first').attr('href', panorama_file + image);
                    } else {
                        $('<a/>').attr('href', panorama_file + image).attr('data-lightbox', 'panorama').addClass('hidden').appendTo('.Plan__details__floor__caption .panorama');
                    }
                }
            }

            svg.show();

            if ($('.Plan__overview').is(':visible')) {
                $('.Plan__overview').fadeToggle(function () {
                    $('.Plan > .container').fadeToggle();
                });
            }
        });
    }

    function displayUnit(unit) {
        var conditions = {
            suite: unit
        };

        $.ajax({
            url: '/api/plans',
            type: 'get',
            data: conditions
        }).done(function (data) {
            var unit = data[0];
            $('.Plan .Plan__details__unit').remove();
            unit.surface_area_translated = $('.Plan__overview select[name=surface-area] option[value="' + unit['surface-area'] + '"]').text();
            unit.bedrooms_translated = $('.Plan__overview select[name=bedrooms] option[value="' + unit.bedrooms + '"]').text();
            $('.Plan__details').append(hbs_details(unit));
        });
    }
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// all.min.js